import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { toast, Toaster } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();

  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) return toast.error("Password must be at least 8 characters.");
    if (pw !== confirm) return toast.error("Passwords don't match.");
    if (!token) return toast.error("Missing reset token — request a new link.");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password updated. Sign in with the new one.");
      setTimeout(() => navigate("/admin/login"), 1200);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail, "Reset failed"));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-cream px-6" data-testid="reset-password-page">
      <Toaster position="top-center" richColors />
      <div className="max-w-sm w-full">
        <img
          src="https://customer-assets-cm19k8pv.emergentagent.net/job_goa-art-space/artifacts/47po7jix_final%20logo%20no%20background%20.png"
          alt="Carpe Diem Goa"
          className="h-20 w-auto object-contain -ml-1 mb-6"
        />
        <div className="overline">Admin</div>
        <h1 className="display text-4xl mt-3">Set new password.</h1>

        {!token ? (
          <p className="text-red-800 text-sm mt-4">This link is missing its token. Please request a new reset link.</p>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-4">
            <label className="block">
              <span className="overline">New password (min 8)</span>
              <input
                required
                type={show ? "text" : "password"}
                value={pw}
                onChange={(e) => setPw(e.target.value)}
                autoComplete="new-password"
                className="w-full bg-transparent border-b border-charcoal py-2 text-base focus:outline-none"
                data-testid="reset-new"
              />
            </label>
            <label className="block">
              <span className="overline">Confirm</span>
              <input
                required
                type={show ? "text" : "password"}
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                autoComplete="new-password"
                className="w-full bg-transparent border-b border-charcoal py-2 text-base focus:outline-none"
                data-testid="reset-confirm"
              />
            </label>
            <label className="flex items-center gap-2 text-xs text-muted2">
              <input type="checkbox" checked={show} onChange={(e) => setShow(e.target.checked)} />
              Show passwords
            </label>
            <button type="submit" disabled={busy} className="btn-primary w-full justify-center" data-testid="reset-submit">
              {busy ? "Updating…" : "Set new password"}
            </button>
          </form>
        )}

        <div className="mt-8 text-xs">
          <Link to="/admin/login" className="link-hover">← Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
